import * as yup from 'yup'

export const FreightCapabilitySchema = yup.object({
  isFtlCapable: yup.boolean(),
  isLtlCapable: yup.boolean(),
  isIntermodalCapable: yup.boolean(),
  isDrayageCapable: yup.boolean(),
})

export type TFreightCapabilitySchema = yup.InferType<typeof FreightCapabilitySchema>
